var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReturnReplacementScreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
    fill: "#146EB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5319 16.1667H14.4681C13.6487 16.1667 13 16.8082 13 17.6184V24.8599C13 25.6532 13.6487 26.3116 14.4681 26.3116H16.5337V46.3817C16.5337 47.1751 17.1824 47.8334 18.0018 47.8334H45.9982C46.8005 47.8334 47.4663 47.192 47.4663 46.3817V26.3116H49.5319C50.3342 26.3116 51 25.6701 51 24.8599V17.6184C51 16.8251 50.3513 16.1667 49.5319 16.1667ZM25.2645 24.551C25.6144 24.1712 26.1816 24.1712 26.5315 24.551C26.8814 24.9307 26.8814 25.5464 26.5315 25.9262L23.9935 28.6808H42.169C42.6639 28.6808 43.065 29.1162 43.065 29.6532C43.065 30.1903 42.6639 30.6257 42.169 30.6257H21.8496C21.6139 30.6312 21.3766 30.5363 21.1967 30.3411C21.0888 30.224 21.0142 30.0845 20.9728 29.9363C20.9478 29.8468 20.9343 29.7517 20.9343 29.6532C20.9343 29.3783 21.0394 29.1301 21.2083 28.9532L25.2645 24.551ZM21.8302 34.1885H42.169C42.3985 34.1884 42.6288 34.2833 42.8039 34.4734C43.1538 34.8531 43.1538 35.4688 42.8039 35.8486L38.7361 40.2635C38.3862 40.6432 37.8189 40.6432 37.469 40.2635C37.1191 39.8837 37.1191 39.268 37.469 38.8883L40.0073 36.1334H21.8302C21.3354 36.1334 20.9343 35.698 20.9343 35.161C20.9343 34.6239 21.3354 34.1885 21.8302 34.1885Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnReplacementScreenIcon);
export default __webpack_public_path__ + "static/media/return-replacement-screen-icon.b21157091c5577760ee4e8529d8d00f0.svg";
export { ForwardRef as ReactComponent };